<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-flex">
                <div class="uk-margin-large-right">
                    <ul class="uk-subnav uk-subnav-line">
                        <li class="uk-disabled"><a href="">Staff</a></li>
                        <li
                            v-for="filterable_role in filterable_roles"
                            :key="filterable_role.id"
                            :class="{'uk-active': (state.filter.indexOf(filterable_role.id) >= 0)}"
                        >
                            <a href @click.prevent="toggle_role_filter(filterable_role.id)">
                                {{ filterable_role.name }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="uk-subnav uk-subnav-line">
                        <li class="uk-disabled"><a href="">Studio</a></li>
                        <li :class="{'uk-active': !state.studio_id}"><a href @click.prevent="set_state_value('studio_id', '')">Any</a></li>
                        <li
                            v-for="studio in studios"
                            :key="studio.id"
                            :class="{'uk-active': state.studio_id === studio.id}"
                        >
                            <a href @click.prevent="set_state_value('studio_id', studio.id)">{{ studio.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="uk-flex-item-1">
                    <div class="uk-float-right uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 weeks
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 26}"
                            @click.prevent="set_scope(26)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 52}"
                            @click.prevent="set_scope(52)"
                        >
                            1 year
                        </base-button>
                    </div>
                </div>
            </div>
            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <office-workload-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :y-max="ymax"
                        style="height: 600px;"
                    />
                    <div class="uk-button-group lam-graph-toggles">
                        <base-button
                            flavor="link"
                            size="mini"
                            @click.prevent="datasets_set_visibility(false)"
                        >
                            Hide All
                        </base-button>
                        <base-button
                            flavor="link"
                            size="mini"
                            @click.prevent="datasets_set_visibility(true)"
                        >
                            Show All
                        </base-button>
                    </div>
                </div>
            </div>
        </div>
    </report>
</template>

<script type="text/javascript">
// :export-url="`/report/${report_id}/export?version_id=${state.version_id}`"
import is_big_report from "./IsBigReport"
import handles_projects from "./HandlesProjects"

import Report from "./Report.vue"
import BaseButton from "../../ui/BaseButton"
import OfficeWorkloadGraph from "./OfficeWorkloadGraph.js"

export default {
    mixins: [is_big_report, handles_projects],
    components: {
        Report,
        BaseButton,
        OfficeWorkloadGraph
    },
    methods: {
        toggle_role_filter (role_id) {
            const index = this.state.filter.indexOf(role_id)
            const roles = [...this.state.filter]
            if(index >= 0) roles.splice(index, 1)
            else roles.push(role_id)
            this.set_state_value("filter", roles)
        }
    },
    computed: {
        chart_data () {
            const data = { labels: [], datasets: [] }
            let range_start = this.$moment()
            if(this.state.version_id) {
                const version = this.versions.find(version => version.id === this.state.version_id)
                range_start = this.$moment(version.start)
            }
            range_start.startOf("week")
            const range_end = this.$moment(range_start).add(this.state.scope, "weeks")

            if(this.report) {
                // const is_filtered = (!!this.state.filter.length || !!this.state.studio_id)
                const user_datasets = {}
                const office_avg_dataset = { // office average w/o cb
                    label: "_AVG",
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    borderColor: "#000000",
                    cubicInterpolationMode: "monotone",
                    fill: "origin",
                    borderWidth: 1,
                    pointRadius: 0,
                    borderDash: [5, 3],
                    data: [],
                    extra_data: []
                }
                /*
                const avg_dataset = {
                    label: "_FA", // absolute average w/o cb
                    backgroundColor: "rgba(239, 178, 45, 0.54)",
                    borderColor: "#FF6709",
                    cubicInterpolationMode: "monotone",
                    fill: "origin",
                    borderWidth: 1,
                    pointRadius: 0,
                    borderDash: [5, 3],
                    data: [],
                    extra_data: []
                }
                */
                const pa_dataset = {
                    label: "_PA", // office average w/ cb
                    // backgroundColor: "rgba(239, 178, 45, 0.54)",
                    backgroundColor: "#FF6709",
                    borderColor: "#FF6709",
                    // cubicInterpolationMode: "monotone",
                    // fill: "origin",
                    // borderWidth: 1,
                    // pointRadius: 0,
                    borderDash: [5, 3],
                    fill: false,
                    data: [],
                    extra_data: []
                }
                const report_dataset = this.report.dataset
                const nb_days = 5
                let total_usable_hours = 0
                this.raw_user_records.forEach(user => {
                    if(!user.proxy && (user.role <= this.$root.constants.roles.PRINCIPAL.id)) {
                        const day_hours = this.$root.applicationSettings.work_day_hours * ((user.annual_utilisation_rate || 0) / 100)
                        total_usable_hours += (day_hours * nb_days)
                    }
                })

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.ymax = 0
                Object.keys(report_dataset).forEach(date_string => {
                    const date = this.$moment(date_string)

                    if(date.isSameOrAfter(range_start) && date.isSameOrBefore(range_end)) {
                        data.labels.push(date.format("MMM Do"))
                        const stats = {
                            total_with_cb: 0,
                            total_without_cb: 0,
                            total_available_hours: 0,
                            office_total_with_cb: 0,
                            office_total_without_cb: 0
                        }

                        const role_filtered = this.state.filter.length !== this.filterable_roles.length
                        Object.keys(report_dataset[date_string]).forEach(initials => {
                            if(initials !== "_cb") {
                                const user = this.raw_user_records.find(user => user.initials === initials)
                                if(
                                    user && (user.role <= this.$root.constants.roles.PRINCIPAL.id)
                                ) {
                                    const user_is_considered = (!role_filtered || ((this.state.filter.indexOf(user.role) >= 0) && !user.proxy)) && (!this.state.studio_id || (this.state.studio_id === user.studio_id)) // true if no filter applied OR if filter considers this user

                                    if(user_is_considered && !user_datasets[initials]) {
                                        user_datasets[initials] = {
                                            label: user.proxy ? `_${user.initials}` : user.initials,
                                            backgroundColor: user.hex_color,
                                            borderColor: user.hex_color,
                                            fill: false,
                                            data: [],
                                            extra_data: []
                                        }
                                    }

                                    const hours = parseFloat(report_dataset[date_string][initials]) || 0
                                    const day_hours = this.$root.applicationSettings.work_day_hours * ((user.annual_utilisation_rate || 0) / 100)
                                    const workload = day_hours ? parseFloat((hours / (day_hours * nb_days)) * 100) : 0
                                    if(user_is_considered) {
                                        stats.total_available_hours += (day_hours * nb_days)
                                        user_datasets[initials].data.push(workload)
                                        user_datasets[initials].extra_data.push(hours)
                                    }

                                    this.ymax = Math.max(workload, this.ymax)

                                    const on_leave = (user.on_leave && (!user.on_leave_since || this.$moment(user.on_leave_since).isSameOrBefore(date)) && (!user.on_leave_until || this.$moment(user.on_leave_until).isSameOrAfter(date)))
                                    if(!on_leave) {
                                        if(user_is_considered) {
                                            stats.total_with_cb += hours
                                            stats.total_without_cb += hours
                                        }
                                        stats.office_total_with_cb += hours
                                        stats.office_total_without_cb += hours
                                    }
                                }
                            }
                        })

                        // avg_dataset.data.push(stats.total_available_hours ? (stats.total_without_cb / stats.total_available_hours) * 100 : 0)
                        office_avg_dataset.data.push(total_usable_hours ? (stats.office_total_without_cb / total_usable_hours) * 100 : 0)
                        office_avg_dataset.extra_data.push(stats.office_total_without_cb)

                        if(!user_datasets._cb) { // Crystal Ball (without chosen pending)
                            user_datasets._cb = {
                                label: "_CB",
                                backgroundColor: "#0000ff",
                                borderColor: "#0000ff",
                                borderDash: [5, 3],
                                fill: false,
                                data: [],
                                extra_data: []
                            }
                        }

                        let hours = parseFloat(report_dataset[date_string]._cb) || 0
                        // let workload = (total_usable_hours ? parseFloat((hours / total_usable_hours) * 100) : 0)
                        let workload = this.$root.applicationSettings.work_day_hours ? parseFloat((hours / (this.$root.applicationSettings.work_day_hours * nb_days)) * 100) : 0
                        user_datasets._cb.data.push(workload)
                        user_datasets._cb.extra_data.push(hours)
                        this.ymax = Math.max(workload, this.ymax)

                        stats.total_with_cb += hours
                        stats.office_total_with_cb += hours

                        if(!user_datasets._cp) { // Chosen Pending projects
                            user_datasets._cp = {
                                label: "_CP",
                                backgroundColor: "#7901d4",
                                borderColor: "#7901d4",
                                borderDash: [5, 3],
                                fill: false,
                                data: [],
                                extra_data: []
                            }
                        }
                        hours = parseFloat(report_dataset[date_string]._cp) || 0
                        // workload = (total_usable_hours ? parseFloat((hours / total_usable_hours) * 100) : 0)
                        workload = this.$root.applicationSettings.work_day_hours ? parseFloat((hours / (this.$root.applicationSettings.work_day_hours * nb_days)) * 100) : 0
                        user_datasets._cp.data.push(workload)
                        user_datasets._cp.extra_data.push(hours)
                        this.ymax = Math.max(workload, this.ymax)

                        stats.total_with_cb += hours
                        stats.office_total_with_cb += hours

                        pa_dataset.data.push(total_usable_hours ? (stats.office_total_with_cb / total_usable_hours) * 100 : 0)
                        pa_dataset.extra_data.push(hours)
                    }
                })
                data.datasets = Object.values(user_datasets)
                data.datasets.push(pa_dataset)
                data.datasets.push(office_avg_dataset)
                // if(is_filtered) data.datasets.push(avg_dataset)
            }

            return data
        }
    },
    data () {
        return {
            report_id: "office_workload",

            default_state: {
                scope: 6, // nb_weeks
                mode: "absolute",
                filter: [
                    window.nibnut.vue.constants.roles.DESIGNER.id,
                    window.nibnut.vue.constants.roles.LIGHTING_DESIGNER.id,
                    window.nibnut.vue.constants.roles.SENIOR_LIGHTING_DESIGNER.id,
                    window.nibnut.vue.constants.roles.ASSOCIATE.id,
                    window.nibnut.vue.constants.roles.SENIOR_ASSOCIATE.id,
                    window.nibnut.vue.constants.roles.ASSOCIATE_PRINCIPAL.id,
                    window.nibnut.vue.constants.roles.PRINCIPAL.id
                ],
                user_id: 0,
                studio_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
